import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from 'reducer/store';

const isLogin = createSlice({
  name: 'isLogin',
  initialState: false,
  reducers: {
    setLoginRedux: (state, action: PayloadAction<boolean>) => action.payload,
  },
});
// 取值 get
export const getLoginReducer = (state: RootState) => state.isLoginReducer;
// set
export const loginAction = isLogin.actions;
const isLoginReducer = isLogin.reducer;
export default isLoginReducer;
